<template>
  <div class="row">
    <div class="row">
      <h3>Especialidade - {{ nomeEspecialidade }}</h3>
    </div>
    <div class="col">
      <a-table :dataSource="subEspecialidades" :columns="columns">
        <template #action="{ record }">
          <a @click="adicionar(record)" v-if="!record.adicionado"><i class="fas fa-add icon-add"></i></a>
          <a @click="removerSubEspecialidade(record)" v-if="record.adicionado"><i class="fas fa-trash icon-trash"></i></a>
        </template>
      </a-table>
      <div class="row">
        <div class="col d-flex justify-content-center">
          <button @click="voltar" class="btn btn-success" style="margin-right: 10px">Voltar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createEspecialidade, getEspecialidadeById } from '@/components/service/especilidadeService';
import { domainSubEspecialidade } from '@/utils/servicos-utils';
import { openNotification, typesNotification } from '@/utils/notifications';

export default {
  name: 'FormSubEspecialidade',

  data() {
    return {
      subEspecialidades: [],
      idEspecialidade: null,
      nomeEspecialidade: null,
      columns: [
        {
          title: 'Sub Especialidade',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  async created() {
    if (this.$route.query.id) {
      this.idEspecialidade = this.$route.query.id;
      await this.getEspecialidadeSelect();
    }
  },
  methods: {
    async getEspecialidadeSelect() {
      await getEspecialidadeById(this.idEspecialidade).then(async (esp) => {
        let subEspecialidadsBaseRemota = [];
        this.nomeEspecialidade = esp.data.especialidade.nome;
        await domainSubEspecialidade(esp.data.especialidade.id).then((r) => (subEspecialidadsBaseRemota = r.data));
        if (subEspecialidadsBaseRemota.length > 0 && esp.data.subEspecialidade) {
          for (let subEspRem of subEspecialidadsBaseRemota) {
            for (let subEspLocal of esp.data.subEspecialidade) {
              if (subEspRem.id === subEspLocal.id) {
                subEspRem['adicionado'] = true;
              }
            }
          }
        }
        this.subEspecialidades = subEspecialidadsBaseRemota;
      });
    },
    async adicionar(subEspecialidade) {
      await createEspecialidade(await this.montarObjetoEspecialidade(subEspecialidade))
        .then(async () => {
          openNotification(typesNotification.success, 'Adicionado com sucesso.');
          await this.getEspecialidadeSelect();
        })
        .catch((er) => console.log(er));
    },
    async removerSubEspecialidade(subEspecialidade) {
      await createEspecialidade(await this.removerObjetoEspecialidade(subEspecialidade))
        .then(async () => {
          openNotification(typesNotification.success, 'Removido com Sucesso.');
          await this.getEspecialidadeSelect();
        })
        .catch((er) => console.log(er));
    },
    async montarObjetoEspecialidade(subEspecialidade) {
      let especialidade = {};
      await getEspecialidadeById(this.idEspecialidade).then(async (esp) => {
        especialidade = esp.data;
        if (especialidade.subEspecialidade && especialidade.subEspecialidade.length > 0) {
          especialidade.subEspecialidade.push(subEspecialidade);
        } else {
          let newArray = [];
          newArray.push(subEspecialidade);
          especialidade.subEspecialidade = newArray;
        }
      });
      return especialidade;
    },
    async removerObjetoEspecialidade(subEspecialidade) {
      let especialidade = {};
      await getEspecialidadeById(this.idEspecialidade).then(async (esp) => {
        especialidade = esp.data;
        especialidade.subEspecialidade.splice(especialidade.subEspecialidade.indexOf(especialidade.subEspecialidade.find((e) => e.id === subEspecialidade.id)), 1);
      });
      return especialidade;
    },
    voltar() {
      this.$router.push('/page-sub-especialidade');
    },
  },
};
</script>

<style scoped></style>
